import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

const SITE_ORIGIN = 'https://gabrieledenaro.com';

/**
 * Keeps the <link rel="alternate" hreflang="..."> tags in sync with the
 * current SPA route. IT is the only real indexable variant — there is no
 * translated EN content behind `?lang=en` (it's a client-side UI toggle,
 * not a distinct crawlable page), so we don't claim an EN alternate.
 */
export default function useHreflang() {
  const { pathname } = useLocation();

  useEffect(() => {
    const path = pathname || '/';
    const variants = [
      { hreflang: 'it', href: `${SITE_ORIGIN}${path}` },
      { hreflang: 'x-default', href: `${SITE_ORIGIN}${path}` },
    ];

    // Remove all previous hreflang links (static + dynamic).
    document
      .querySelectorAll('link[rel="alternate"][hreflang]')
      .forEach((el) => el.remove());

    // Append the fresh ones for the current route.
    variants.forEach(({ hreflang, href }) => {
      const link = document.createElement('link');
      link.setAttribute('rel', 'alternate');
      link.setAttribute('hreflang', hreflang);
      link.setAttribute('href', href);
      link.setAttribute('data-hreflang-dynamic', 'true');
      document.head.appendChild(link);
    });

    // Canonical: bare URL of the current page (no query params).
    let canonical = document.querySelector('link[rel="canonical"]');
    if (!canonical) {
      canonical = document.createElement('link');
      canonical.setAttribute('rel', 'canonical');
      document.head.appendChild(canonical);
    }
    canonical.setAttribute('href', `${SITE_ORIGIN}${path}`);
  }, [pathname]);
}
